module.exports = require("./../../_gen/starling/assets/DataLoader");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/assets/DataLoader.js
// module id = 154
// module chunks = 0